// extracted by mini-css-extract-plugin
module.exports = {"mainPage":"MainPage_mainPage__EoIMC","wrapper":"MainPage_wrapper__32Lcb"};